import { bannerText, t, type EmulationState } from '@bms2/shared';
import styles from './shell.module.css';

/**
 * 🔨 A persistent banner, Viewing as Jane Doe with Exit, sits under the Global
 * Header for the whole emulation (piece 12, decision 0188), and the header's own
 * avatar stays the real person's. 💰 Mail and notifications produced by an
 * emulated write are real in production, which is why the banner is loud.
 */
export interface EmulationBannerProps {
  state: EmulationState;
  onExit: () => void;
}

export function EmulationBanner({ state, onExit }: EmulationBannerProps) {
  const text = bannerText(state);
  if (!text) return null;
  return (
    <div className={styles.emulationBanner} role="status" data-shell="emulation-banner">
      <span>{text}</span>
      <button type="button" className={styles.headerButton} onClick={onExit} data-shell="emulation-exit">{t('shell.exitEmulation')}</button>
    </div>
  );
}
